import { ref, createApp, h } from 'vue'
import Toast from '@/views/components/Toast.vue'

const toastInstances = ref([])

export function useToast() {
  const showToast = (message, type = 'success', duration = 3000) => {
    // Create a container for the toast
    const container = document.createElement('div')
    document.body.appendChild(container)

    // Create the toast component instance
    const app = createApp({
      render() {
        return h(Toast, {
          message,
          type,
          duration,
          onClose: () => {
            app.unmount()
            document.body.removeChild(container)
          }
        })
      }
    })

    app.mount(container)
  }

  const success = (message, duration) => showToast(message, 'success', duration)
  const error = (message, duration) => showToast(message, 'error', duration)
  const warning = (message, duration) => showToast(message, 'warning', duration)
  const info = (message, duration) => showToast(message, 'info', duration)

  return {
    showToast,
    success,
    error,
    warning,
    info
  }
}
